<template>
    <div class="zygote-interaction" :class="{inline: activation === 'text'}">
        <div class="simulation-button flex flex-align" v-if="activation === 'button'" @click="go">
            <div class="ff">{{text}}</div>
            <div class="simulation-button-arrow"></div>
        </div>
        <simulation v-else-if="activation === 'inline'" ref="simulation" />
        <a v-else-if="activation === 'text'" class="" @click="go">{{text}}</a>
    </div>
</template>

<script>
    export default {
        name: 'ZygoteInteraction',
        props: {
            code: String,
            activation: String,
            text: String
        },
        methods: {
            go(){
                this.$store.dispatch('chapters/simulation', {type: 'code', code: this.code});
            }
        },
        mounted(){
            this.$nextTick(() => {
                if(this.activation === 'automatic'){
                    //Send a message through the iframe.
                    this.$store.dispatch('chapters/simulation', {type: 'code', code: this.code});
                }else if(this.activation === 'inline'){
                    this.$refs.simulation.execute({
                        type: 'code',
                        code: this.code
                    });
                }
            });
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .simulation-interaction
    {
        &.inline
        {
            display: inline;
        }

        .simulation-button
        {
            margin: 20px 50px;
            // padding: 30px 45px 30px 50px;
            padding: 15px 20px;
            background: var(--input-background-color);
            border: 1px solid var(--input-border-color);
            border-radius: 3px;
            color: @base;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: all ease 0.2s;

            &:hover, &:active
            {
                background: var(--modal-background-color);

                .simulation-button-arrow
                {
                    transform: translate(10px, 0);
                }
            }
        }

        .simulation-button-arrow
        {
            width: 24px;
            height: 24px;
            background: url('~@/assets/icons/base/arrow-right.svg');
            transition: all ease 0.2s;
        }

        iframe
        {
            height: 500px;
        }
    }

    @media only screen and (max-width: 1100px)
    {
        .simulation-interaction
        {
            .simulation-button
            {
                margin: 20px 30px;
                font-size: 15px;
            }
        }
    }
</style>
